import React from 'react';
import { StandardMenuType } from './types';
/**
 * This context is used to determine what keyboard input handling we should be doing
 */
var StandardMenuContext = React.createContext({
    menuType: StandardMenuType.DROPDOWN,
    role: undefined,
});
export default StandardMenuContext;
//# sourceMappingURL=context.js.map